import { Component, type ErrorInfo, type ReactNode } from 'react';
import { logger } from '../../utils/logger';
import {
  ERROR_BOUNDARY_LOG_ACTION,
  ERROR_BOUNDARY_LOG_CODE,
} from './constants';
import ErrorBoundaryFallback from './Fallback';
import { getErrorBoundaryMetadata } from './utils';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error(
      ERROR_BOUNDARY_LOG_CODE,
      ERROR_BOUNDARY_LOG_ACTION,
      undefined,
      undefined,
      getErrorBoundaryMetadata(error, errorInfo),
    );
  }

  private handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return <ErrorBoundaryFallback onRetry={this.handleRetry} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
